<modal
  *ngIf="isModalOpen"
  [modalConfiguration]="modalConfiguration"
  (modalCloseEvent)="closeModal()"
>
  <div class="px-3 mt-2">
    <div class="row">
      <div class="col-1">
        <img class="warning-icon" [src]="'./assets/icons/warning.svg'" alt="" />
      </div>
      <div class="col-10">
        <div
          class="d-flex align-items-start alert-icon"
          [innerHTML]="PendingVerifyInfo"
        ></div>
      </div>
    </div>
  </div>
</modal>
